<template>
  <v-row no-gutters>
    <v-col cols="6" v-for="item in items" :key="item.name">
      <v-icon :color="getColor(item.name)">
        {{ getIcon(item.name) }}
      </v-icon>
      {{ item.name }}
    </v-col>
  </v-row>
</template>

<script>
import {
  mdiCheckboxBlankCircleOutline,
} from '@mdi/js';
import factoryChecks from '../mixins/factoryChecks';

export default {
  name: 'FactoryItemChecks',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  mixins: [factoryChecks],
  data() {
    return {
      /**
      * icons
      */
      mdiCheckboxBlankCircleOutline,
      /**
      * variables
      */
    };
  },
  computed: {
    /**
     * Returns the items property
     */
    items() {
      // const { cannedMenuItems, driedMenuItems } = this;
      // const menuItems = [];
      return [];
    },
  },
  methods: {
    getColor(arr) {
      const count = arr?.length ?? 0;
      switch (count) {
        default:
        case 0:
          return 'error';
        case 1:
          return 'default';
      }
    },
    getIcon(arr) {
      const count = arr?.length ?? 0;
      switch (count) {
        default:
        case 0:
          return this.mdiCheckboxBlankCircleOutline;
        case 1:
          return this.mdiCheckCircleOutline;
      }
    },
  },
};
</script>
